export default {"src":"/uk/_next/static/media/pensionbeeLogo.dd6769fe.svg","height":105,"width":320,"blurWidth":0,"blurHeight":0};